import apiClient from "../Util/ApiClient";

export default class CurrencyApi {

    static filter = (query = {}) => {
        return apiClient.get('/currencies', {
            params: query
        })
    };
}